import React from 'react';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { withLocalize } from 'react-localize-redux';
import Message from '../../common/message';

class CeeErrorMessage extends React.Component {
    render() {
        if (isNullOrUndefined(this.props.errors) || this.props.errors.length === 0)
            return null;

        return (
            <Message type="error" message={this.props.translate("Error.InvalidParams")} style={this.props.style}>
                <ul style={{ listStyleType: "disc" }}>
                    {this.props.errors.map(k => <li key={k} style={{ marginLeft: "3em" }}>{this.translateErrorItem(this.mapItem(k))}</li>)}
                </ul>
            </Message>
        );
    }

    translateErrorItem = (item) =>
        (isNullOrUndefined(item) || item.length < 1) ? null : this.props.translate(`Search.Common.${item[0].toUpperCase()}${item.slice(1)}`);

    mapItem = (item) => {
        switch (item) {
            case "poIco":
            case "foIco":
                return "CompanyId";
            case "birth":
                return "Pid";
            default:
                return item;
        }
    }
}

export default withLocalize((CeeErrorMessage));